import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Menu from "./components/Menu";
import LGPD from "./components/LGPD";
import Footer from "./components/Footer";

import {
  Header,
  About,
  Content,
  FormPage,
  Success,
  Privacy,
} from "./pages";

function App() {
  return (
    <Router>
      <div className="App">
        <Menu />
        <LGPD />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <About />
                <Content />
                <FormPage />
              </>
            }
          />
          <Route path="/sucesso" element={<Success />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
